(() => {
  if (window.ggShippingDetailsReady || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
  window.ggShippingDetailsReady = true;
  let active = null;
  let sequence = 0;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-gg-shipping-open]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const template = trigger.closest('[data-gg-buying-summary]')?.querySelector('[data-gg-shipping-template]');
    if (!template) return;
    event.preventDefault();
    if (active?.open) return;
    const dialog = template.content.firstElementChild.cloneNode(true);
    const heading = dialog.querySelector('[data-gg-shipping-heading]');
    heading.id = 'gg-shipping-title-' + (++sequence);
    dialog.setAttribute('aria-labelledby', heading.id);
    document.body.append(dialog);
    const oldOverflow = document.documentElement.style.overflow;
    let outsideDown = false;
    const outside = (e) => {
      const r = dialog.getBoundingClientRect();
      return e.target === dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom);
    };
    dialog.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll('button, a[href]')];
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    dialog.addEventListener('pointerdown', e => { outsideDown = outside(e); });
    dialog.addEventListener('click', e => {
      if (e.target.closest('[data-gg-shipping-close]') || (outsideDown && outside(e))) dialog.close();
      outsideDown = false;
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = oldOverflow;
      active = null;
      dialog.remove();
      if (trigger.isConnected) trigger.focus({ preventScroll: true });
    }, { once: true });
    try {
      dialog.showModal();
      active = dialog;
      document.documentElement.style.overflow = 'hidden';
      dialog.querySelector('[data-gg-shipping-close]').focus({ preventScroll: true });
    } catch (_) {
      dialog.remove();
      window.location.assign(trigger.href);
    }
  });
})();
